import React, { useRef } from "react";
import { isBoolean } from "lodash";
import { Stepper as PrimeStepper } from 'primereact/stepper';
import { StepperPanel } from "primereact/stepperpanel";

import Button from "./Button";


function Stepper(props) {
    const { steps } = props
    const stepperRef = useRef(null)

    const submitBtnLabel = props.submitBtnLabel || "Submit"
    
    const handleOnSubmit = () => {
        if(props.onSubmit){
            props.onSubmit()
        }
    }

    const handleOnNext = async (step) => {
        if(step.onNext){
            const triggerNext = await step.onNext()
            if(triggerNext !== true){
                return
            }
        }
        stepperRef.current.nextCallback()
    }

    return (
        <PrimeStepper ref={stepperRef} linear>
            {
                steps.map((step, index) => {
                    const isLastStep = index === steps.length - 1
                    const isFirstStep = index === 0

                    return (
                        <StepperPanel header={step.header} disabled key={`steps-${step.stepId || index}`}>
                            <div className="flex flex-column">
                                <div className="border-2 border-dashed surface-border border-round font-medium" style={{ width: "100%" }}>
                                    {step.content}
                                </div>
                            </div>
                            <div className="flex pt-2 justify-content-between">
                                {!isFirstStep && 
                                    <Button
                                        label="Back"
                                        severity="secondary"
                                        icon="pi pi-arrow-left"
                                        onClick={() => stepperRef.current.prevCallback()}
                                    />
                                }
                                {!isLastStep && 
                                    <>
                                        <div></div>
                                        <Button
                                            label="Next"
                                            icon="pi pi-arrow-right"
                                            iconPos="right"
                                            onClick={() => handleOnNext(step)}
                                            style={{ background: '#06b6d4', color: '#ffffff' }}
                                        />
                                    </>
                                }
                                { isLastStep && 
                                    <Button
                                        label={submitBtnLabel}
                                        className="bg-purple-400 border-purple-300 hover:border-purple-600"
                                        onClick={handleOnSubmit}
                                    />
                                }
                            </div>
                        </StepperPanel>
                    )
                }
            )}
        </PrimeStepper>
    )
}

export default Stepper;